interface SparklineProps {
  /** Valeurs, index 0 = plus ancienne. */
  values: number[];
  /** Décrit la série pour les lecteurs d'écran (ex : "CA 4 semaines"). */
  label: string;
  /** Si fourni, remplace l'aria-label auto-généré (ex : valeurs formatées en euros). */
  ariaLabel?: string;
  className?: string;
}

const W = 96;
const H = 28;
const PAD = 2;

/**
 * Sparkline SVG inline. Polyline normalisée sur [min, max].
 * Si max === min (série plate ou unique), trace une ligne médiane.
 */
export function Sparkline({ values, label, ariaLabel, className }: SparklineProps) {
  const n = values.length;
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = max - min;

  const points = values
    .map((v, i) => {
      const x = n === 1 ? W / 2 : PAD + (i * (W - 2 * PAD)) / (n - 1);
      const y =
        range === 0
          ? H / 2
          : H - PAD - ((v - min) * (H - 2 * PAD)) / range;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <svg
      role="img"
      aria-label={ariaLabel ?? `${label} : ${values.join(', ')}`}
      viewBox={`0 0 ${W} ${H}`}
      className={className}
      width={W}
      height={H}
      preserveAspectRatio="none"
    >
      <polyline
        points={points}
        fill="none"
        stroke="var(--cime-primary)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
